import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Icon, Tooltip } from '@doxyme/ui';
import { PAYMENT_INTERVAL } from './index';
import Price from '../../../../core/components/price';
export function SeatsDescription({ planInterval, basePrice, currencyCode, }) {
    const descriptionLabel = planInterval === PAYMENT_INTERVAL.ANNUAL
        ? 'auth.payment-setup.billed-annually-each'
        : 'auth.payment-setup.billed-monthly-each';
    return (<div className="payment-setup__seats-description-container">
      <div className="payment-setup__seats-label">
        <span>
          <FormattedMessage id="auth.payment-setup.seats"/>
        </span>
        <Tooltip tabIndex={-1} id="tax-tooltip" content={<FormattedMessage id="auth.payment-setup.seats-tooltip-message"/>} size="large" theme="light" pointer={true} pointerPosition="top-center">
          <Icon className="tax-tooltip-icon" name="help" size="xx-small"/>
        </Tooltip>
      </div>

      <div className="payment-setup__price-description">
        <FormattedMessage id={descriptionLabel} values={{
            price: (<Price item={basePrice} currency={currencyCode} showDecimals={true}/>)
        }}/>
      </div>
    </div>);
}
